import React from 'react';
import propTypes from './propTypes';

const AboutAlertsAgro = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.53 19L12 5.99L4.47 19H9V21H1L12 2L23 21H15V19H19.53Z" fill="currentColor" />
    <path d="M11 21V19H13V21H11Z" fill="currentColor" />
    <path d="M11 11H13V17H11V11Z" fill="currentColor" />
  </svg>
);

AboutAlertsAgro.propTypes = propTypes;

export default AboutAlertsAgro;
